<router-outlet></router-outlet>
<div *ngIf="loading | async" class="fixed inset-0 h-screen w-screen z-20 flex items-center justify-center" style="background: rgba(255, 255, 255, 0.7)">
    <mat-spinner></mat-spinner>
</div>